import React from "react"

import i18n from "@/i18n"

import { type ReservationDurationOption } from "../reservation_duration_options"

type DurationScrollerProps = {
  options: ReservationDurationOption[]
  selectedSeconds: number | null
  onSelect: (seconds: number) => void
}

const DurationScroller: React.FC<DurationScrollerProps> = ({ options, selectedSeconds, onSelect }) => {
  return (
    <div
      className="-mx-5 flex gap-3 overflow-x-auto px-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      data-testid="public-venue-mobile-booking-duration-scroller"
    >
      {options.map((option) => {
        const isSelected = selectedSeconds === option.seconds

        return (
          <button
            key={option.seconds}
            type="button"
            onClick={() => onSelect(option.seconds)}
            aria-pressed={isSelected}
            data-selected={isSelected}
            data-testid={`public-venue-mobile-booking-duration-option-${option.minutes}`}
            className={`flex h-[40px] w-[70px] shrink-0 flex-col items-center justify-center gap-[2px] rounded-[6px] border-[0.5px] transition-colors ${
              isSelected ? "border-[#2176c1] bg-[#2596fa]" : "border-[#e5e6ec] bg-white"
            }`}
          >
            <span className={`text-[12px] leading-none ${isSelected ? "text-white" : "text-[#0c1930]"}`}>
              {option.label}
            </span>
            <span className={`text-[8px] leading-none ${isSelected ? "text-white/80" : "text-[#929baa]"}`}>
              {i18n.t("app.public.venue.mobile_booking.duration_minutes", { count: option.minutes })}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default DurationScroller
